import { Injectable, inject } from '@angular/core'

import { combine, createStore } from 'effector'

import { getInstanceActionsByNodeType } from '@flowx/designer/modules/bpmn-editor/fabric-actions.util'
import { BpmnEditorEffects } from '@flowx/designer/modules/bpmn-editor/store/bpmn-editor.effects'
import { BpmnEditorEvents } from '@flowx/designer/modules/bpmn-editor/store/bpmn-editor.events'
import { BpmnEditorStore } from '@flowx/designer/modules/bpmn-editor/store/bpmn-editor.store'
import { ApplicationDetailsStore } from '@flowx/designer/modules/projects/store/application-version-details.store'
import { AppEvents } from '@flowx/designer/shared/effector/app/app.events'
import { BpmnEditorStores } from '@flowx/designer/shared/effector/bpmn-editor/bpmn-editor.stores'
import { BpmnNodeEvents } from '@flowx/designer/shared/effector/bpmn-editor/bpmn-node.events'

@Injectable()
export class BpmnInstanceActionsStore {
  // ⚠️ DO NOT remove bpmnEditorEffects and bpmnEditorEffect , it is required for the effector samples to be initialized
  // noinspection JSUnusedLocalSymbols
  #bpmnEditorEffects = inject(BpmnEditorEffects)
  // noinspection JSUnusedLocalSymbols
  #bpmnEditorStores = inject(BpmnEditorStore)

  #applicationDetailsStore = inject(ApplicationDetailsStore)
  #definitionExists = this.#applicationDetailsStore.definitionExists
  #showBpmnActions$ = createStore<boolean>(false, {
    name: 'showBpmnActions$',
  })
    .on([BpmnNodeEvents.nodeLeftClick], () => true)
    .reset([
      BpmnNodeEvents.nodeRightClick,

      BpmnEditorEvents.swimlaneLeftClick,
      BpmnEditorEvents.canvasZoom,
      BpmnEditorEvents.canvasLeftClick,
      BpmnEditorEvents.canvasPan,
      AppEvents.processDiagramDestroy,
    ])

  readonly #bpmnActionsStyles$ = createStore({ transform: null }, { name: 'bpmnActionsStyles$' })
    .on(BpmnNodeEvents.nodeLeftClick, (_, { viewportCoords: { x, y, width, height } }) => ({
      transform: `translate(${x + width / 2}px, ${y + height}px)`,
    }))
    .on(this.#showBpmnActions$, (state, show) => (show ? state : { transform: null }))

  readonly #bpmnActionsOptions$ = createStore([], { name: 'bpmnActionsOptions$' }).on(
    BpmnEditorStores.selectedNode$,
    (_, selectedNode) =>
      selectedNode
        ? getInstanceActionsByNodeType(selectedNode.type, this.#definitionExists())
        : []
  )

  readonly #bpmnActionsDisplayItemsCount$ = BpmnEditorStores.multiselection$.map(
    (selection) => selection.length
  )

  readonly bpmnInstanceActions$ = combine({
    show: this.#showBpmnActions$,
    styles: this.#bpmnActionsStyles$,
    options: this.#bpmnActionsOptions$,
    displayItemsCount: this.#bpmnActionsDisplayItemsCount$,
  }).map(({ show, styles, options, displayItemsCount }) => ({
    show,
    styles,
    displayItemsCount,
    options,
  }))
}
